import { render } from "./CpaReport.vue?vue&type=template&id=6ba97fa8&scoped=true"
import script from "./CpaReport.vue?vue&type=script&lang=js"
export * from "./CpaReport.vue?vue&type=script&lang=js"

import "./CpaReport.vue?vue&type=style&index=0&id=6ba97fa8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba97fa8"]])

export default __exports__